module.exports = __webpack_public_path__ + "img/dotstableAblack2.f7560fcd.png";